import {
  Container,
  IsRequiredStar,
  Label,
  Select,
  Span,
} from "../../Styles/Global.Styled";
import { css } from "styled-components";

const cntStyle = (width, height, disabled) => css`
  width: ${width};
  height: ${height};
  opacity: ${disabled && "0.5"};
`;
const mbCntStyle = (width, height) => css`
  width: ${width};
  height: ${height};
`;
const labelDefault = css`
  position: absolute;
  height: 95%;
  padding: 0 1vh;
`;
const labelActive = css`
  position: absolute;
  height: 1.3vh;
  top: -1vh;
  left: 1vh;
  background-color: white;
  font-size: 1.5vh;
  z-index: 2;
`;
const inputStyle = css`
  width: 100%;
  padding: 0 1vh;
  z-index: 1;
`;
const errorTxt = css`
  position: absolute;
  color: red;
  bottom: -2vh;
  left: 0;
  font-size: 1.25vh;
`;

const SelectInput = ({ index, properties, setForm }) => {
  const {
    width,
    height,
    mWidth,
    mHeight,
    name,
    label,
    required,
    value,
    options,
    errors,
    disabled,
  } = properties ?? {};

  const handleChange = (e) => {
    const newValue = e.target.value;
    setForm((prev) => {
      const updatedForm = [...prev];
      updatedForm[index].value = newValue;
      return updatedForm;
    });
    if (errors !== null) {
      runValidation(e);
    }
  };

  const runValidation = (e) => {
    const selectedValue = e.target.value;

    setForm((prev) => {
      const updatedForm = [...prev];
      updatedForm[index].errors =
        required && !selectedValue ? `${label} is required` : false;
      return updatedForm;
    });
  };

  return (
    <Container
      $baseStyle={cntStyle(width, height, disabled)}
      $mStyle={mbCntStyle(mWidth, mHeight)}
    >
      <Label htmlFor={name} $baseStyle={value ? labelActive : labelDefault}>
        {label}
        {required && <IsRequiredStar />}
      </Label>
      <Select
        $error={errors}
        $baseStyle={inputStyle}
        value={value}
        id={name}
        required={required}
        disabled={disabled}
        onChange={handleChange}
        onBlur={(e) => {
          if (errors === null) return runValidation(e);
        }}
      >
        <option value="" disabled />
        {options?.map((option) => (
          <option key={option}>{option}</option>
        ))}
      </Select>
      {errors && <Span $baseStyle={errorTxt}>{errors}</Span>}
    </Container>
  );
};

export default SelectInput;
